/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "REGION": "us-east-1",
    "USER_POOL_ID": "us-east-1_SXKXJyMgG",
    "USER_POOL_APP_CLIENT_ID": "247m5qkotpdefkfpq0abssc9s7"
};


export default awsmobile;
